export enum FILE_MEMBERSHIP {
  GROUP = 'GROUP',
  ROLE = 'ROLE',
}
